<div style="height: 100vh; width:100vw; display : flex; flex-direction: column; align-items: center;">
    <div style="height:10vh; width: 100%;
    background: linear-gradient(to bottom, #00c6df, #ffffff 100%);">

    </div>
    <div style="font-family: Country; font-size: 175%;">
        Anatomy of a Panic Attack
    </div>
    <div class="bt-container">
        <div *ngIf="page1">
            
            <div *ngFor="let i of locations1; let ind=index" >
                <button class="btn" [style.margin-left.%]="i.x"
                    [style.margin-top.%]="i.y" id="btn{{ind}}" (click)="click(ind)"></button>
                <div class="rect-container" [style.margin-left.%]="i.x"
                    [style.margin-top.%]="i.y" id="rect{{ind}}">{{prob[ind]}}</div>
            </div>
            <div style="position: absolute; margin-top: 80%; font-size: 150%;">
                Symptoms
            </div>
            <button class="cont" *ngIf="showcont" (click)="toggle()">
                Continue
            </button>
        </div>
        <div *ngIf="!page1">
            <div *ngFor="let i of locations2; let ind=index" >
                <button class="btn" [style.margin-left.%]="i.x"
                    [style.margin-top.%]="i.y" id="btn{{ind}}" (click)="click(ind)"></button>
                <div class="rect-container" [style.margin-left.%]="i.x"
                    [style.margin-top.%]="i.y" id="rect{{ind}}">{{soln[ind]}}</div>
            </div>
            <div style="position: absolute; width:8vw; margin-top: 80%; font-size: 150%;">
                How to Get Through It
            </div>
        </div>

    </div>
</div>